import { put, takeLatest } from "redux-saga/effects";
import {
  fetchRestaurantGroups,
  setCurrentLanguage,
} from "../app_manager/actionCreators";
import {
  FETCH_AUTH_ITEMS,
  FETCH_AUTH_ITEMS_ERROR,
  FETCH_AUTH_ITEMS_SAGA,
  FETCH_AUTH_ITEMS_SUCCESS,
} from "./types/actionTypes";

function decodeJwtPayload(token: string): Record<string, any> {
  try {
    const part = token.split(".")[1];
    const padded = part + "==".slice(0, (4 - (part.length % 4)) % 4);
    return JSON.parse(atob(padded.replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return {};
  }
}

function extractRoles(payload: Record<string, any>): string[] {
  const roles =
    payload["cognito:groups"] ||
    payload["groups"] ||
    payload["roles"] ||
    payload["role"] ||
    [];
  return Array.isArray(roles) ? roles : [roles].filter(Boolean);
}

export function* fetchAuthItemsRequest(action: any): any {
  try {
    yield put({ type: FETCH_AUTH_ITEMS });
    const token = localStorage.getItem("token");
    if (!token) {
      yield put({ type: FETCH_AUTH_ITEMS_ERROR });
      return;
    }
    const payload = decodeJwtPayload(token);
    console.debug("[auth] JWT payload keys:", Object.keys(payload));

    const userRole: string[] = extractRoles(payload);
    const username: string =
      payload["cognito:username"] ||
      payload["username"] ||
      payload["preferred_username"] ||
      payload["email"] ||
      payload["sub"] ||
      "";

    console.debug("[auth] userRole:", userRole, "username:", username);

    localStorage.setItem("username", username);
    // Only overwrite userRole if we extracted something; otherwise keep what login set
    if (userRole.length > 0) {
      localStorage.setItem("userRole", JSON.stringify(userRole));
    }

    const language = localStorage.getItem("currLanguage");
    if (!userRole.includes("Callcenter")) {
      yield put(fetchRestaurantGroups());
    }
    if (language) {
      yield put(setCurrentLanguage(language));
    }

    const finalRoles: string[] = JSON.parse(
      localStorage.getItem("userRole") || "[]"
    );
    yield put({ type: FETCH_AUTH_ITEMS_SUCCESS, payload: finalRoles });
  } catch (e) {
    yield put({ type: FETCH_AUTH_ITEMS_ERROR });
  }
}

export function* authSagas(): any {
  yield takeLatest(FETCH_AUTH_ITEMS_SAGA, fetchAuthItemsRequest);
}
